/**
 * The console's single definition of "home" (DNKADM-0288): the landing target
 * for the index redirect, the post-auth fallback, the sign-in return targets,
 * the 404 recovery link, Front Desk entry, and the Front-Desk config bounce.
 *
 * `/reservations` — its index view defaults to the Now & Next daily board
 * (DNKADM-0271), so landing here puts daily work front and centre (the nav
 * rebuild's premise, `docs/design/dink-admin-nav-rebuild-plan.md`).
 *
 * Deliberately a standalone module with no imports so every home site
 * (including `router.tsx` itself) can reference it without a circular import.
 */
export const HOME_PATH = '/reservations';
